/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcHeadphoneRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M6.9 15.001v1a.9.9 0 0 1-.9.9 4.9 4.9 0 0 1-.851-9.727 6.901 6.901 0 0 1 13.702 0 4.901 4.901 0 0 1-.204 9.684 6.92 6.92 0 0 1-3.197 4.118 1 1 0 0 1-.098.05A2.9 2.9 0 0 1 12.5 23.4h-1a2.9 2.9 0 0 1 0-5.8h1a2.9 2.9 0 0 1 2.538 1.497A5.1 5.1 0 0 0 17.1 15V8A5.1 5.1 0 1 0 6.9 8zM5.1 9.033a3.101 3.101 0 0 0 0 5.934zm13.8 5.934a3.101 3.101 0 0 0 0-5.934zM10.4 20.5a1.1 1.1 0 0 1 1.1-1.1h1a1.1 1.1 0 0 1 0 2.2h-1a1.1 1.1 0 0 1-1.1-1.1"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcHeadphoneRegular;
